module.exports = __webpack_public_path__ + "static/img/er_xs.9bf30cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/er_xs.jpg
// module id = KUvf
// module chunks = 1